import React from 'react'
import { createPortal } from 'react-dom'

interface HtGoldViewportLayerProps {
  children: React.ReactNode
}

/**
 * Portal host for theme FAB + bottom dock.
 * Pure CSS `position:fixed; inset:0` — no visualViewport JS sync
 * (that sync was yanking mobile scroll back to top every few seconds).
 */
const HtGoldViewportLayer: React.FC<HtGoldViewportLayerProps> = ({ children }) => {
  const node = <div className="htg-vv-layer">{children}</div>

  if (typeof document === 'undefined') return node
  return createPortal(node, document.body)
}

export default HtGoldViewportLayer
